module.exports = __webpack_public_path__ + "static/media/reload.44f75b59.svg";